<template>
  <div>
    <PhotoReportItemComponent
      menu="evaluation"
    >
    </PhotoReportItemComponent>
  </div>
</template>
<script>

import PhotoReportItemComponent from '../../PhotoReport/components/PhotoReportItemComponent.vue'
import PageModel from '../../main/pages/PageModel.vue'

export default {
  extends: PageModel,
  components: {
    PhotoReportItemComponent
  },
  
  data() {
    return {
    }
  },

}
</script>